<template>
  <div>
    <slot name='icon' :device='device'></slot>
    <span :class="{'color-red bolder':device.status === ENUM_SENSOR_STATUS.OFFLINE}">
      <slot name='name' :device='device'></slot>
    </span>
    <i v-if='device.config_status === ENUM_CONFIG_STATUS.CONFIGURING'
       v-icon="['configStatusConvert', device.config_status]"></i>
  </div>
</template>

<script>
import { ENUM_CONFIG_STATUS, ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'

export default {
  computed: {
    ENUM_CONFIG_STATUS: () => ENUM_CONFIG_STATUS,
    ENUM_SENSOR_STATUS: () => ENUM_DEVICE_STATUS
  },
  props: {
    device: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped lang='scss'>

</style>
